// import Meal from './Meal';

export default {
  // component: Meal,
  component: load(() => import(/* webpackChunkName: "Feed-Meal" */ './Meal')),
  priority: 13,
  permissions: ["FeedingConsoleMenu/FoodMealMenu"],
  name: app.translate('routes.home.feed.Meal'),
  icon: 'format-list-bulleted-type',
  drawer: true,
};


